'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissAttachmentsError = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var dismissAttachmentsError = exports.dismissAttachmentsError = (0, _reduxActions.createAction)(_fileUploadsActionTypes.DISMISS_ATTACHMENTS_ERROR);


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/dismissAttachmentsError.js
// module id = 654
// module chunks = 2 3